import { format } from "date-fns";
import Papa from "papaparse";
import { toast } from "sonner";

interface AllUsersExportRow {
  "Full Name": string;
  Email: string;
  Role: string;
  Onboarded: string;
  Verified: string;
  "Profile Published": string;
  Phone: string;
  Parish: string;
  Country: string;
  "LinkedIn URL": string;
  "Curricula Enrolled": number;
  "Courses Enrolled": number;
  "Registered On": string;
}

/**
 * Exports the given list of user/profile records (as produced by the
 * `all_users_full` query on the Admin > User Management tab) to a CSV file.
 * Pass the currently filtered list to export just that subset, or the full
 * `allUsers` array to export every registrant.
 */
export function exportAllUsersCSV(users: any[] | undefined | null): void {
  if (!users || users.length === 0) {
    toast.error("No users to export");
    return;
  }

  const rows: AllUsersExportRow[] = users.map((u) => ({
    "Full Name": u.full_name || "Unknown",
    Email: u.email || "N/A",
    Role: u.role || "N/A",
    Onboarded: u.is_onboarded ? "Yes" : "No",
    Verified: u.is_verified ? "Yes" : "No",
    "Profile Published": u.is_published ? "Yes" : "No",
    Phone: u.phone || "",
    Parish: u.parish || "",
    Country: u.country || "",
    "LinkedIn URL": u.linkedin_url || "",
    "Curricula Enrolled": (u.curriculum_ids || []).length,
    "Courses Enrolled": (u.course_ids || []).length,
    "Registered On": u.created_at ? format(new Date(u.created_at), "yyyy-MM-dd") : "N/A",
  }));

  // Sort by registration date, most recent first
  rows.sort((a, b) => b["Registered On"].localeCompare(a["Registered On"]));

  const csv = Papa.unparse(rows);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", `eab_connect_registrants_${format(new Date(), "yyyy-MM-dd")}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  toast.success(`Exported ${rows.length} registrant${rows.length === 1 ? "" : "s"}!`);
}
